import { Badge, Card, Col, Placeholder, Row } from "react-bootstrap";

export const SectionDDXButton = (props: {
    idx: number,
    active?: number,
    setActive: (active: number) => void,
    data: any,
}) => {

    return (
        <Card onClick={() => {props.setActive(props.idx)}} className={`notes-section ${props.active === props.idx && "notes-section-active"}`}>
            <Card.Body>
                <Row>
                    <Col md={10}>
                        <strong>#{props.idx + 1} {props.data && props.data.diagnosis}</strong>
                    </Col>
                    <Col md={2} className="text-right">
                        {
                            props.data && props.data.high_risk && (
                                <small><Badge bg="danger">High Risk</Badge></small>
                            )
                        }
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );
};
